import { LeadsStatuses, LeadsStatusesTranslate } from '@/enums';
import { BaseApiService } from '@/services/base-service';
import { AxiosPromise } from 'axios';
import { BaseResponse, Response, TableRequest } from '@/types';
import { Leads } from '../types';

export class LeadsService extends BaseApiService {
  private readonly base_path = 'partner/leads';

  async get_leads(filters: TableRequest<Leads.RequestFilters>): Promise<Leads.Response> {
    const payload = filters;

    const { data } = await this.http_client.get<Leads.Response>(this.base_path, {
      params: {
        filters: payload.filters,
        filters_exist: payload.filters_exist,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async get_lead_by_id(id: string | number): Promise<Response<Leads.LeadResponse>> {
    const url = `${this.base_path}/${id}`;
    const { data } = await this.http_client.get<Response<Leads.LeadResponse>>(url);

    return data;
  }

  async get_lead_logs(id: string | number): Promise<Response<Leads.LeadLog[]>> {
    const url = `${this.base_path}/${id}/logs`;
    const { data } = await this.http_client.get<Response<Leads.LeadLog[]>>(url);

    return data;
  }

  add_lead_log(id: string | number, payload: { comment: string }): AxiosPromise {
    const url = `${this.base_path}/${id}/logs`;

    return this.http_client.post(url, payload);
  }

  async reserve_lead_page(id: string | number): Promise<void> {
    const url = `${this.base_path}/${id}/activity`;

    await this.http_client.post<void>(url);
  }

  async unreserve_lead_page(id: string | number): Promise<void> {
    const url = `${this.base_path}/${id}/activity`;

    await this.http_client.delete<void>(url);
  }

  async upd_lead(payload: Leads.UpdLeadPayload): Promise<BaseResponse> {
    const url = `${this.base_path}/${payload.id}`;
    const { data } = await this.http_client.patch<BaseResponse>(url, payload);

    return data;
  }

  async add_lead_reminder(id: string | number, payload: Leads.LeadReminder): Promise<BaseResponse> {
    const url = `${this.base_path}/${id}/reminders`;
    const { data } = await this.http_client.post<BaseResponse>(url, payload);

    return data;
  }

  async delete_lead_reminder(reminder_id: string | number): Promise<BaseResponse> {
    const url = `${this.base_path}/reminders/${reminder_id}`;

    const { data } = await this.http_client.delete<BaseResponse>(url);

    return data;
  }
}

export const default_lead = (): Leads.Lead => ({
  lead_date: '',
  last_modified_date: '',
  lead_number: '',
  company_name: '',
  author_appeal: '',
  lead_status: {
    slug: LeadsStatuses.NEW,
    name: LeadsStatusesTranslate[LeadsStatuses.NEW],
  },
  city: '',
  region: '',
  telephone: '',
  email: '',
  topic_of_appel: '',
  sale_amount: '',
  source: '',
  comment: '',
  description: '',
  edited_by_user: '',
  is_editing_not_available: false,
  has_unread_change: false,
  lead_category_id: null,
  lead_category_name: null,
  type: '',
  reminders: [],
});

export const default_lead_log = (): Leads.ItemLog => ({
  user_name: '',
  user_role: '',
  comment: '',
  date: '',
});
